import React from 'react';
import FilterMenuButton from './FilterMenuButton';
import {useSelector, useDispatch} from 'react-redux';
import FilterList from './FilterList';
import {clearAll, selectActiveFiltersCount} from './../store/filters';
import { toggleFilterVisible } from '../store/app';


const Filters = (props) => {
    const filterCollapsed = useSelector(state => state.app.filterCollapsed);
    const isSmallScreen = useSelector(state => state.app.smallScreen);
    const mobileHeader = document.getElementById("nav-app").cloneNode(true);
    let filterRef = React.useRef(null);
    let firstUpdate = React.useRef(true);
    const activeFilterCount = useSelector(selectActiveFiltersCount);
    let dispatch = useDispatch();
    let [applyFiltersVisible, setApplyFiltersVisible] = React.useState(false);
    let optionChanged = useSelector(state => state.filters.optionChanged);
    //const firstUpdate = React.useRef(true);

    React.useEffect(() => {
        if (isSmallScreen && filterRef.current !== null) {
            filterRef.current.insertBefore(mobileHeader, filterRef.current.childNodes[0]);
        } else if (!isSmallScreen && filterRef.current !== null) {
            for(let i = 0; i < filterRef.current.children.length; i++) {
                // Remove mobile menu when leaving mobile mode
                if (filterRef.current.children.item(i).className === mobileHeader.className) {
                    filterRef.current.removeChild(filterRef.current.children.item(i));
                    break;
                };
            }
        }
    },[filterRef, isSmallScreen]);

    React.useLayoutEffect(() => {
        // uses useRef as a sort of instance variable to keep track of whether it is the first render or not
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        setApplyFiltersVisible(true);
    }, [optionChanged, activeFilterCount])

    return (
        <aside id={"filter"} ref={filterRef} className={filterCollapsed ? "collapsed" : ""}>
            <div className={"mobileMenu"}>
                <FilterMenuButton />
                {
                    // display clear all button if active filters
                    activeFilterCount > 0 ? <button className={"btn menuBtn mobileBtn filterBtn"} onClick={(e) => {e.preventDefault(); dispatch(clearAll());}}>Clear All</button> : ""
                }
            </div>
            <FilterList />
            {props.children}
            <button 
                className={`btn applyFilterBtn ${applyFiltersVisible ? "" : "hidden"}`}  
                onClick={(e) => {
                    e.preventDefault();
                    setApplyFiltersVisible(false);
                    dispatch(toggleFilterVisible());
                }}
            >
                Apply filter
            </button>
        </aside>
    )
}

export default Filters;